var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"active-business-process-container"},_vm._l((_vm.items),function(item,index){return _c('EcsBusinessProcessElement',{key:((item.label) + "-" + index),attrs:{"label":item.label,"value":item.value}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }